import { useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import './AllBrandsFilters.scss';
import { useFiltersData } from './AllBrands.hooks';

const numberFormatter = new Intl.NumberFormat();

const AllBrandsFilters = props => {
  // Data
  const { query, filters, setFilters } = props;
  const { isFetching, results } = useFiltersData(query, filters);

  const missingDataFields = [
    { label: 'name', field: 'missingNameCount' },
    { label: 'domain', field: 'missingDomainCount' },
    { label: 'logo', field: 'missingLogoCount' },
    { label: 'industry', field: 'missingIndustryCount' }
  ];

  const getLoadingRow = idx => <div key={idx} className={'all-brands-filters-loading-row'} />;

  // Actions
  const updateFilter = useCallback(
    (category, name, value) => {
      setFilters(prev => {
        if (value) {
          return [...prev, [category, name]];
        } else {
          return prev.filter(([key, value]) => key !== category || value !== name);
        }
      });
    },
    [setFilters]
  );

  return (
    <div className='all-brands-filters-outer'>
      <p className='all-brands-filters-subheader'>Incomplete Listings</p>
      {isFetching
        ? _.range(4).map(getLoadingRow)
        : missingDataFields.map(({ label, field }) => (
            <label key={field}>
              <input
                type='checkbox'
                checked={filters.some(([key, value]) => key === 'missing' && value === label)}
                onChange={e => {
                  updateFilter('missing', label, e.target.checked);
                }}
              />
              <span className='all-brands-filters-name'>Needs {label}</span>
              <span className='all-brands-filters-count'>{results[field]}</span>
            </label>
          ))}
      <p className='all-brands-filters-subheader'>Industry</p>
      {isFetching
        ? _.range(4).map(getLoadingRow)
        : results.industryCounts.map(({ id, name, count }) => (
            <label key={id}>
              <input
                type='checkbox'
                checked={filters.some(([key, value]) => key === 'industry' && value === id)}
                onChange={e => {
                  updateFilter('industry', id, e.target.checked);
                }}
              />
              <span className='all-brands-filters-name'>{name}</span>
              <span className='all-brands-filters-count'>{numberFormatter.format(count)}</span>
            </label>
          ))}
    </div>
  );
};

AllBrandsFilters.propTypes = {
  filters: PropTypes.array.isRequired,
  setFilters: PropTypes.func.isRequired
};

export default AllBrandsFilters;
